import { render, staticRenderFns } from "./SelectPersonType.vue?vue&type=template&id=6f2c3af5&scoped=true&"
import script from "./SelectPersonType.vue?vue&type=script&lang=js&"
export * from "./SelectPersonType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c3af5",
  null
  
)

export default component.exports